module.exports = __webpack_public_path__ + "img/icon_sign.ef7e626e.png";